module.exports = __webpack_public_path__ + "img/NC.57ca02e1.png";